import React from 'react';

interface Props {
  id: string;
}
export const CarrierImplement = ({ id, }:Props) => {
  return (
    <div>
      realizacje { id }
    </div>
  );
};
